function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.3.5h-8.6c-2.2 0-3.9 1.8-4 3.9v21.1c0 2.2 1.8 3.9 4 3.9h8.6c2.2 0 3.9-1.8 3.9-3.9V4.4c0-2.1-1.7-3.9-3.9-3.9zM17.4 2v2.1c0 .2-.1.4-.2.6-.1.2-.3.3-.5.3h-3.3c-.5 0-.9-.4-.9-.9V2h4.9zm-6.7 0h.3v2.2c0 1.3 1.1 2.3 2.3 2.3h3.4c.6 0 1.2-.3 1.6-.8.4-.5.6-1 .6-1.7V2h.4c1.4 0 2.5 1.1 2.5 2.5v20.4H8.2V4.4C8.3 3.1 9.4 2 10.7 2zm8.6 26h-8.6c-1.1 0-2-.7-2.3-1.7h13.3c-.4 1-1.3 1.7-2.4 1.7z",
  fill: "currentColor"
})));